export default function options(data) {
  return data.map((option) => {
    const firstLetter = option.title[0]
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    }
  })
}
